// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"Post_blogPost__gnjQr"};